export default "__VITE_ASSET__DtLMv_Do__"